import { createStore } from 'services/Flux'
import { actionsType } from 'config/constants'


const updateReceiverData = (state, action) => {
    if (!action.payload && action.payload.receiverData) {
        return state;
    }

    let newState = { ...state };
    let receiverData = {};

    if (action.payload.receiverData) {
        receiverData = action.payload.receiverData
    }

    newState.receiverData = receiverData;

    return newState;
}


const updateOrderInfo = (state, action) => {
    if (!action.payload && action.payload.skuData) {
        return state;
    }
    let newState = { ...state };
    let replacementCriteria = {
        skuData: action.payload.skuData
    };

    if (action.payload.substituteType) {
        replacementCriteria.substituteType = action.payload.substituteType
    }

    newState.replacementCriteria = replacementCriteria;
    newState.receiverData = action.payload.receiverData || null;

    return newState;
}

const setLoading = (state, action) => {
    if (!action.payload) {
        return state;
    }

    let newState = { ...state };
    newState.loading = action.payload.loading;
    newState.partialLoading = action.payload.partialLoading;
    return newState;
}

const updateOrderForm = (state, action) => {
    let newState = { ...state };

    if (!action.payload) {
        return state;
    }

    newState.orderForm = {...newState.orderForm, ...action.payload.orderForm};

    return newState;
}


const Store = createStore((state, action) => {
    switch (action.type) {
        case actionsType.CART_LOADING:
            return setLoading(state, action);

        case actionsType.GET_CART:
            return updateOrderForm(state, action);

        case actionsType.SET_CUPON:
            return updateOrderForm(state, action);

        case actionsType.CLEAR_CART:
            return updateOrderForm(state, action);

        case actionsType.UPDATE_CART:
            return updateOrderForm(state, action);

        case actionsType.ADD_ITEM_CART:
            return updateOrderForm(state, action);

        case actionsType.REMOVE_ITEM_CART:
            return updateOrderForm(state, action);

        case actionsType.SET_PAYMENT:
            return updateOrderForm(state, action);

        case actionsType.GET_ORDER_INFO:
            return updateOrderInfo(state, action);

        case actionsType.SET_ORDER_INFO: 
            return updateOrderInfo(state, action);

        case actionsType.SET_SHIPPING_DATA:
            return updateOrderForm(state, action);

        case actionsType.SET_RECEIVER_DATA:
            return updateReceiverData(state, action);

        case actionsType.SET_PROFILE_DATA:
            return updateOrderForm(state, action);


        default:
            return state;
    }
}, {
    orderForm: null,
    loading: false,
    partialLoading: false,
    replacementCriteria: null,
    receiverData: null
}, 'cart');

export default Store;

